export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/2-22a3e10fabf4edcca3e41fad2640e135.png";